import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TitleBar from "../common-components/TitleBar";
import Grid from "@mui/material/Grid2";
import {
  DownloadIcon,
  EyeIcon,
  PDFIcon,
} from "../../assets/Icon/dashboredIcon";
import PreviewModal from "../itin/PreviewModal";
import {
  downloadFile,
  getOperatingAgreementDetail,
} from "../../stores/clients";
import { useDispatch } from "react-redux";
import moment from "moment";
import theme from "../../theme";
import { useNavigate, useParams } from "react-router-dom";
import ListLoadingNew from "../common-components/ListLoadingNew";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { setToast } from "../../stores/toast/toastslice";
import { toPreviewUrl, toStorageKey } from "../../utils/fileUrl";

const OAStepThree = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [oaDetail, setOaDetail] = useState<any>();
  const [openPreview, setOpenPreview] = useState(false);
  const [fileUrl, setFileUrl] = useState<any>();
  const handleClose = () => setOpenPreview(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchDetails = async () => {
    await dispatch<any>(
      getOperatingAgreementDetail({ order_id: Number(id) ?? 0 }),
    )
      .then(async (res: any) => {
        console.log(res, "-------------");
        if (res?.payload?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                res?.payload?.data?.message ||
                (typeof res?.payload?.data?.message === "string" &&
                  res?.payload?.data?.message) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            navigate("/tools/operating-agreement/list");
          }, 2000);

          return () => clearTimeout(timeout);
        }
        setLoading(false);
        // if (!res?.payload?.data) {
        //   navigate("/tools/operating-agreement/list");
        //   return;
        // }
        setOaDetail(res?.payload?.data);
      })
      .catch((error: any) => {
        navigate("/tools/operating-agreement/list");
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const generated_agreement_file = oaDetail?.generated_agreement_file ?? "";
  const agreementKey = toStorageKey(generated_agreement_file);
  const name = agreementKey.split("/").pop();

  const handleOnClickPreview = async (params: any) => {
    // The agreement PDF is produced server side; until it exists there is
    // nothing to preview or download, so don't open a broken viewer or send
    // `?url=null` to the download endpoint.
    if (!agreementKey) {
      dispatch<any>(
        setToast({
          message:
            "Your Operating Agreement is still being prepared. Please check back shortly.",
          type: "error",
          title: "Not ready yet",
        }),
      );
      return;
    }

    if (params === 1) {
      setIsPreviewing(true);
      setOpenPreview(true);
      setFileUrl(toPreviewUrl(generated_agreement_file));
      setIsPreviewing(false);
    } else {
      setIsDownloading(true);
      const response = await dispatch(
        downloadFile({ url: agreementKey }) as any,
      ).unwrap();
      if (response?.status === 1) {
        window.open(response?.data);
      } else {
        dispatch<any>(
          setToast({
            message: response?.message || "Unable to download this file.",
            type: "error",
            title: "Error",
          }),
        );
      }
      setIsDownloading(false);
    }
  };
  console.log(isMobile, isTablet);

  if (loading) return <ListLoadingNew />;

  return (
    <Box sx={{ height: "calc(100vh - 120px)" }}>
      <Button
        sx={{
          mb: 0.5,
          color: "#6C6F71",
          display: "flex",
          alignItems: "center",
          fontSize: "16px",
          fontWeight: 600,
          gap: 0.5,
          ml: -2,
        }}
        onClick={() => navigate("/tools/operating-agreement/list")}
      >
        <ArrowBackIosNewIcon /> Back
      </Button>
      <Grid container>
        <Grid size={{ xs: 12, md: 12, lg: 7 }}>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <TitleBar
              title="Your Operating Agreement is Completed! "
              description="You can fill out any additional empty sections internally. It's optional, not a requirement."
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid size={{ xs: 12, md: 12, lg: 7 }}>
          <Box
            sx={{
              backgroundColor: "#fff",
              padding: "20px",
              marginTop: "1.5rem",
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#EAF1FA",
                padding: "20px 20px",
                borderRadius: "10px",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "flex-start" : "center",
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: isMobile ? "100%" : "80%",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    padding: "10px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "0.4px solid #A7C7EA",
                  }}
                >
                  <PDFIcon />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#05000B",
                      wordBreak: "break-all",
                      width: "100%",
                    }}
                  >
                    {name || "Operating Agreement"}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#6C6F71",
                    }}
                  >
                    {moment(oaDetail?.created_at).format("MMMM DD, YYYY")}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  width: isMobile ? "100%" : "20%",
                }}
              >
                <Typography
                  sx={{
                    backgroundColor: "transparent",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  onClick={() => handleOnClickPreview(1)}
                >
                  {isPreviewing ? (
                    <>
                      <CircularProgress size={20} />
                    </>
                  ) : (
                    <EyeIcon />
                  )}
                </Typography>
                <Typography
                  sx={{
                    backgroundColor: "transparent",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  onClick={() => handleOnClickPreview(2)}
                >
                  {isDownloading ? (
                    <>
                      <CircularProgress size={20} />
                    </>
                  ) : (
                    <DownloadIcon />
                  )}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <PreviewModal
        open={openPreview}
        handleClose={handleClose}
        img={fileUrl ?? ""}
      />
    </Box>
  );
};

export default OAStepThree;
